import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import api from "../api";
import Logo from "../components/Logo";
import { useI18n } from "../i18n";

export default function AdminLogin() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { email, password });
      localStorage.setItem("demiray_token", res.data.access_token);
      localStorage.setItem("demiray_admin_email", res.data.email);
      toast.success("Giriş başarılı");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--bg)] flex flex-col" data-testid="admin-login-page">
      <div className="px-6 lg:px-12 py-6 flex items-center justify-between">
        <Logo size={36} />
        <Link to="/" className="text-xs uppercase tracking-widest text-[var(--text-muted)] hover:text-white flex items-center gap-2" data-testid="back-home-link">
          <ArrowLeft size={14} />
          Anasayfa
        </Link>
      </div>

      <div className="flex-1 flex items-center justify-center px-6 py-12">
        <form
          onSubmit={onSubmit}
          className="w-full max-w-md border border-[var(--border)] bg-[var(--surface)] p-8 md:p-12 space-y-6"
          data-testid="admin-login-form"
        >
          <div>
            <div className="overline mb-3">DEMİRAY · CMS</div>
            <h1 className="font-display text-3xl font-light text-white">{t.admin.login}</h1>
          </div>

          <div>
            <label className="text-xs tracking-widest uppercase text-[var(--text-muted)] mb-2 block">
              Kullanıcı Adı
            </label>
            <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-sharp"
              autoComplete="username"
              required
              data-testid="admin-email-input"
            />
          </div>

          <div>
            <label className="text-xs tracking-widest uppercase text-[var(--text-muted)] mb-2 block">
              {t.admin.password}
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-sharp"
              required
              data-testid="admin-password-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-sharp btn-primary w-full disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : null}
            {t.admin.signIn}
          </button>
        </form>
      </div>
    </div>
  );
}
